import React from 'react';
function TechnologySegment() {
  return (
    <div>
      <h3>Technology</h3>

      <h4>Artificial Intelligence</h4>
      <p>
        Artificial intelligence (AI) is a branch of computer science that focuses on creating intelligent machines capable of performing tasks that typically require human intelligence. It involves various subfields such as machine learning, natural language processing, computer vision, and robotics. AI has applications in diverse domains, including healthcare, finance, and autonomous vehicles.
      </p>

      <h4>Web Development</h4>
      <p>
        Web development involves building websites and web applications using programming languages like HTML, CSS, and JavaScript. It encompasses frontend development, backend development, and database management. Web developers create interactive and user-friendly websites, implement responsive design, and optimize performance for an optimal user experience.
      </p>

      {/* Add more subsegments and content as needed */}
    </div>
  );
}

export default TechnologySegment;
